<template>
<div class="wrapper">
  <div class="title">KZI2</div>
  <div class="value">81.7</div>
</div>
</template>

<script>
import {mapGetters} from "vuex";
// import PageNavigator from "../services/PageNavigator";

export default {
  name: 'AttentionWidget',

  data() {
    return {}
  },

  computed: {
    ...mapGetters(['pages'])
//    ...mapState([])
  },

  methods: {
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wrapper {
    background-color: #ffc000;
    display: flex;
    flex-flow: column;
    height: 100%;
  }

  .title {
    color: white;
    font-size: 2em;
    text-align: center;
    padding-top: 1em;
  }

  .value {
    color: white;
    font-size: 3em;
    text-align: center;
    padding-top: 1em;
  }

</style>
